import { gql } from '@apollo/client';

export default gql`
  query getAssistancePerTrains($trainNumbers: [String]!, $departureDate: String!) {
    getAssistancePerTrains(trainNumbers: $trainNumbers, departureDate: $departureDate) {
      trainNumber
      total
      carriages {
        number
        carriage
      }
    }
  }
`;
